import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "member_raffle_body"
};
const _hoisted_2 = {
  class: "cj"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LuckyGrid = _resolveComponent("LuckyGrid");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/member_raffle/bg.png",
    alt: ""
  }, null, -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_LuckyGrid, {
    ref: "myLucky",
    width: "600px",
    height: "600px",
    activeStyle: $data.activeStyle,
    defaultConfig: $data.defaultConfig,
    prizes: $data.prizes,
    blocks: $data.blocks,
    buttons: $data.buttons,
    onStart: $options.startCallback,
    onEnd: $options.endCallback
  }, null, 8, ["activeStyle", "defaultConfig", "prizes", "blocks", "buttons", "onStart", "onEnd"])])]);
}